module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.9 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix onHide callback issue #1023 @jsonviewer")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime-range.html"
    }
  }, [_vm._v("DatetimeRange")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component #970 @327326724")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Better mask transition")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support tranparent background")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support less variable: @popup-background-color")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix left-menu is shown when swiping right quickly")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Reset props every time plugin.show is called #870 @jsonviewer")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/date.html"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add dateRange tool function")]), _vm._v(" "), _c('li', [_vm._v("[feature] format support string-type of date")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/number.html"
    }
  }, [_vm._v("Number")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add numberRange tool function")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b1b07af", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-0b1b07af"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.9-89.vue
// module id = 2024
// module chunks = 334